/* eslint-disable no-param-reassign */

function throttle(fn, delay) {
  let isThrottled = false;
  let fnArgs;
  let context;
  return function wrapper(...args) {
    if (isThrottled) {
      fnArgs = args;
      context = this;
      return;
    }

    isThrottled = true;
    fn.apply(this, args);

    setTimeout(() => {
      isThrottled = false;
      if (fnArgs) {
        wrapper.apply(context, fnArgs);
        fnArgs = null;
        context = null;
      }
    }, delay);
  };
}

export default {

  install(Vue) {
    Vue.throttle = throttle;
    Vue.prototype.$throttle = throttle;
  },

};
